<template>
  <div class="start flex flex-wrap -mx-2">
    <div class="w-full">
      <h1 class="mb-6">Unser Liefergebiet</h1>
      Wir beliefern Dich in
      <ul>
        <li v-for="hostlocation in hostlocations" class="my-2">
          <strong>{{ hostlocation.item_plz }} {{ hostlocation.item_ort_einfach }}</strong>
          (
          <span v-if="hostlocation.item_mbw > 0">ab {{ hostlocation.item_mbw | pricetag }},</span>
          <span v-if="hostlocation.item_shipping > 0">{{ hostlocation.item_shipping | pricetag }} Lieferkosten</span>
          <span v-if="hostlocation.item_shipping == 0">frei Haus</span>
          )
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'

export default {
  name: 'Lieferorte',

  data () {
    return {
      hostId: window.hostId,
      hostlocations: {}
    }
  },

  created () {
    axios.post(endpoints.hostlocations, {
      'hostId': this.hostId
    })
      .then(response => {
        this.hostlocations = response.data.locations
      })
      .catch(e => {
        console.log(e)
      })
  },

  components: {

  },

  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/locations/index.vue